
import React from "react";

export const LoadingState = () => {
  return (
    <div className="p-8 text-center text-muted-foreground">
      <div className="animate-pulse flex flex-col items-center">
        <div className="h-5 w-24 bg-gray-200 rounded mb-4"></div>
        <div className="h-20 w-full max-w-md bg-gray-100 rounded"></div>
      </div>
      <p className="mt-4">Zoeken...</p>
    </div>
  );
};
